(function($) {
  'use strict';

  $('.js-close-menu').click(function() {
	$('.js-menu-item').removeClass('is-expanded');
	$('.js-menu-open-header').removeClass('is-hidden');
	$('.js-menu-close-header').addClass('is-hidden');
	
	return false;
  });

  $('.js-open-menu').click(function() {
	$('.js-menu-item').addClass('is-expanded');
	$('.js-menu-close-header').removeClass('is-hidden');
	$('.js-menu-open-header').addClass('is-hidden');
	
	return false;
  });

})(jQuery);